// Custom Collection Toggle Filter
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tag-toggle-filter').forEach(initTagToggleFilter);
});

function initTagToggleFilter(section) {

  const buttons = section.querySelectorAll('[data-tag]');
  const collectionHandle = section.dataset.collection;
  const apiUrl = section.dataset.apiUrl;

  if (!collectionHandle) return;

  const getUrlTags = () => {
    const parts = window.location.pathname.split('/');
    if (parts.length < 4) return [];
    return parts[3].split('+').filter(Boolean);
  };

  const activeTags = getUrlTags();
  let activeToggle = null;

  buttons.forEach(btn => {

    const tag = btn.dataset.tag;

    if (activeTags.includes(tag)) {
      btn.classList.add('is-active');
      activeToggle = tag;
    }

    btn.addEventListener('click', () => {
      toggleTag(tag);
    });

  });

  function toggleTag(tag) {

    let tags = getUrlTags();

    if (activeToggle && activeToggle !== tag) {
      tags = tags.filter(t => t !== activeToggle);
    }

    if (activeToggle === tag) {

      tags = tags.filter(t => t !== tag);
      activeToggle = null;

    } else {

      tags.push(tag);
      activeToggle = tag;

    }

    applyTags(tags);
    updateButtonState();

  }

  function applyTags(tags) {

    const basePath = `/collections/${collectionHandle}`;

    let newUrl;

    if (!tags.length) {

      newUrl = `${window.location.origin}${basePath}`;

    } else {

      newUrl = `${window.location.origin}${basePath}/${tags.join('+')}`;

    }

    sendTracking(newUrl);

    window.location.href = newUrl;

  }

  function sendTracking(url) {

    if (!apiUrl) return;

    try {

      const payload = {
        event: "collection_filter_toggle",
        url: url,
        timestamp: new Date().toISOString()
      };

      fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        keepalive: true,
        body: JSON.stringify(payload)
      });

    } catch (error) {

      console.warn('Tracking API Error', error);

    }

  }

  function updateButtonState() {

    buttons.forEach(btn => {

      if (activeToggle === btn.dataset.tag) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }

    });

  }

}